import { Form, useNavigation } from "react-router-dom";

import { Button } from "@/components/clickable";
import { VStack } from "@/components/layout";
import { Textarea } from "@/components/textarea";
import { hasProjectReportFinished, isSubmitting } from "@/utils";

export default function GenerateReport({ project, isPooling, setIsPooling }) {
  const { state } = useNavigation();

  if (hasProjectReportFinished(project)) return <></>;

  return (
    <Form
      method="post"
      onSubmit={() => setIsPooling(true)}
      className="flex max-w-3xl flex-col gap-6"
    >
      {!isSubmitting(state) && !isPooling && (
        <>
          <VStack>
            <p className="text-lg font-medium">Instructions (Optional):</p>
            <p className="max-w-xl">
              Tell Daystrom™ about your case in plain English. Include whether
              this concerns your client or opposition, key individual details
              (age, income, children), case type, specific financial concerns to
              analyze (unusual spending, support payment issues), and relevant
              timeframes for the report.
            </p>
          </VStack>
          <Textarea
            placeholder="Type the instructions here..."
            name="instructions"
          />
        </>
      )}

      <Button
        className="w-fit"
        type="submit"
        isLoading={isSubmitting(state) || isPooling}
      >
        Generate report
      </Button>
    </Form>
  );
}
